import { CorporatePartCostStatus } from 'corporate/enums';

const PricingHelper = {
  isCostingValidByStatus: (status: CorporatePartCostStatus) =>
    ![CorporatePartCostStatus.OLD, CorporatePartCostStatus.EXPIRED].includes(status),
};

export default PricingHelper;
